const { css, nodeName } = require("jquery");

/*==================================================
高専生の採用コース 続きを読む/閉じるボタン
==================================================*/
$('.omission-text').each(function() {
  var height = $(this).height();
  var wid = window.innerWidth;
  if(height < 70.1875 && wid > 576) {
    $(this).addClass('small');
    $(this).prev('.omission-btn').css('display', 'none');
  }
  else if (height < 59 && wid < 575) {
    $(this).addClass('small');
    $(this).prev('.omission-btn').css('display', 'none');
  };
});

/*==================================================
991以上でもっと見るボタンで表示件数操作 （会社概要トップ）
==================================================*/
var timer = false;
$(window).on('load resize', function () {
  if (timer !== false) {
    clearTimeout(timer);
  }
  timer = setTimeout(function() {
    var wid = window.innerWidth;

    if (wid > 991) {
      $('.more-btn').removeClass('open');
      $(".product-more-read-box .more-btn .grad-trigger").removeClass('is-show');
      $(".occupation-more-read-box .more-btn .grad-trigger-o").removeClass('is-show-o');
      $('.product-more-read-content.grad-item').children('#toggleCardProduct').slideUp();
      $('.occupation-more-read-content.grad-item-o').children('#toggleCardOccupation').slideUp();


      $('#toggleCardOccupation').css('display','none');
      $(".occupation-more-read-box .more-btn .grad-trigger-o").off('click');
    $(".occupation-more-read-box .more-btn .grad-trigger-o").on('click',function () {
      $(this).parent('.more-btn').toggleClass('open');
      $(this).toggleClass('is-show-o').parent().next('.occupation-more-read-content.grad-item-o').children('#toggleCardOccupation').slideToggle();
    });

    $('#toggleCardProduct').css('display','none');
      $(".product-more-read-box .more-btn .grad-trigger").off('click');
    $(".product-more-read-box .more-btn .grad-trigger").on('click',function () {
      $(this).parent('.more-btn').toggleClass('open');
      $(this).toggleClass('is-show').parent().next('.product-more-read-content.grad-item').children('#toggleCardProduct').slideToggle();
    });
    };
  }, 200);
});


/*==================================================
display:noneで上記js正しく機能しないためタブを自作
==================================================*/
import Swiper from 'swiper/js/swiper.min';
function jsCompanySlider() {
  if($('#jsCompanySlider').length > 0) {

    const swiperSlides = document.getElementsByClassName('swiper-slide');
    const breakPoint = 992;
    let mySwiper ;
    let mySwiperBool ;


    window.addEventListener('load',()=>{
      if( breakPoint < window.innerWidth){
        mySwiperBool = false;
      }else{
        createSwiper();
        mySwiperBool = true;
      }
    },false);

    window.addEventListener('resize',()=>{
      if( breakPoint < window.innerWidth && mySwiperBool){
        mySwiper.destroy(false,true);
        mySwiperBool = false;
      }else if( breakPoint >= window.innerWidth && !(mySwiperBool)){
        createSwiper();
        mySwiperBool = true;
      }
    },false);

    const createSwiper = () =>{
      mySwiper = new Swiper('#jsCompanySlider', {
        loop: true,
        loopAdditionalSlides: 4,
        slidesPerGroup: 1,
        centeredSlides: false,
        autoplay: 3000,
        speed: 1000,
        slidesPerView: 1,
        spaceBetween: 15,
        observer: true,
        observeParents: true,
        pagination: {
          el: '.attention-slider-pagination-company',
          clickable: true,
        },
        breakpoints: {
          576: {
            spaceBetween: 20
          },
          992: {
            spaceBetween: 30
          },
        }
      });
    }
  }
};
function jsCompanySliderOccupation() {
  if($('#jsCompanySliderOccupation').length > 0) {

    const swiperSlides = document.getElementsByClassName('swiper-slide');
    const breakPoint = 992;
    let mySwiper ;
    let mySwiperBool ;


    window.addEventListener('load',()=>{
      if( breakPoint < window.innerWidth){
        mySwiperBool = false;
      }else{
        createSwiper();
        mySwiperBool = true;
      }
    },false);

    window.addEventListener('resize',()=>{
      if( breakPoint < window.innerWidth && mySwiperBool){
        mySwiper.destroy(false,true);
        mySwiperBool = false;
      }else if( breakPoint >= window.innerWidth && !(mySwiperBool)){
        createSwiper();
        mySwiperBool = true;
      }
    },false);

    const createSwiper = () =>{
      mySwiper = new Swiper('#jsCompanySliderOccupation', {
        loop: true,
        // loopedSlides: swiperSlides.length,
        loopAdditionalSlides: 4,
        slidesPerGroup: 1,
        centeredSlides: false,
        autoplay: 3000,
        speed: 1000,
        slidesPerView: 1,
        spaceBetween: 15,
        observer: true,
        observeParents: true,
        pagination: {
          el: '.attention-slider-pagination-occupation',
          clickable: true,
        },
        breakpoints: {
          576: {
            spaceBetween: 20
          },
          992: {
            spaceBetween: 30
          },
        }
      });
    }
  }
};
// display:none;の前にwisper構築する
jsCompanySlider();
jsCompanySliderOccupation();
// ロード時
$(window).on('load', function() {

  $(".tab-list-company .nav-item-company").on('click',function () { //タブをクリックしたときのファンクションをまとめて指定
    var num = $(".tab-list-company .nav-item-company").index(this); //.index()を使いクリックされたタブが何番目かを調べ、numという変数に代入
    $(".tab-content-company").removeClass('active').fadeOut(300);
    $('.tab-content-company').fadeOut(300); //コンテンツを一度すべて非表示

    $(".tab-content-company").eq(num).addClass('active').fadeIn(300); //クリックされたタブと同じ順番のコンテンツを.activeをクラスに追加して表示

    $(".tab-list-company .nav-item-company .nav-link-company").removeClass('active'); //一度タブについているクラス.activeを消して

    $(this).children('.nav-link-company').addClass('active') //クリックされたタブのみにクラス.activeをつける
  });
  setTimeout(function () {
    $('.tab-content-company').css('display','none');
    $('.nav-link-company.active').trigger('click');
  }, 1);
});


/*==================================================
tabのfixed
==================================================*/
if($('.nav-item-company').length) {
  $(window).on('load', function(){
    $('.tab-list-company').parent('.js-tab-fixed').removeClass('fixed');
  });
  $(function(){
    var fix    = $('.tab-list-company').parent('.js-tab-fixed');
    var fixTop = fix.offset().top;
    var fixTop = fixTop;
    $(window).scroll(function () {
      if($(window).scrollTop() >= fixTop) {
        fix.addClass('fixed');
      } else {
        fix.removeClass('fixed');
      }
    });
  });
};

/*==================================================
体験談のもっと見るボタン
==================================================*/
if($('.experience-more-read-box').length) {
  $(function(){
    $('.js-toggle-experience-more-read-content').css('display','none');
    $(".experience-more-read-box .more-btn .grad-trigger").off('click');
    $(".experience-more-read-box .more-btn .grad-trigger").on('click',function () {
      $(this).parent('.more-btn').toggleClass('open');
      $(this).closest('.experience-more-read-box').toggleClass('open');
      $(this).toggleClass('is-show').parent().next('.js-toggle-experience-more-read-content').slideToggle();
    });
  });
};

/*==================================================
選考のタブ
==================================================*/
// ロード時
$(window).on('load', function() {

  $(".js-tab-senkou-item").on('click',function () { //タブをクリックしたときのファンクションをまとめて指定
    var num = $(".js-tab-senkou-item").index(this); //.index()を使いクリックされたタブが何番目かを調べ、numという変数に代入
    $(".tab-content-senkou").removeClass('active').fadeOut(300);
    $('.tab-content-senkou').fadeOut(300); //コンテンツを一度すべて非表示

    $(".tab-content-senkou").eq(num).addClass('active').fadeIn(300); //クリックされたタブと同じ順番のコンテンツを.activeをクラスに追加して表示

    $(".js-tab-senkou-item").removeClass('active'); //一度タブについているクラス.activeを消して

    $(this).addClass('active') //クリックされたタブのみにクラス.activeをつける
  });
});
/*==================================================
応募確認ダイアログ
==================================================*/
// if($('#reservation-btn').length) {
// $(function () {
//   $(document).on('click', '#reservation-btn', function () {
//     if (!confirm('高専Linkに登録したあなたの名前・メールアドレス・生年月日が企業に開示されます。また、企業とのマッチングが成立し、高専Link上でメッセージのやりとりが可能になります。\nよろしいですか？\n登録情報はマイページより確認・修正できます。')) {
//       return false;
//     }
//     return true;
//   });
//
// });
// }
